module.exports = __webpack_public_path__ + "static/media/contratos.c79d6fea.jpg";